import { FC } from 'react';
import styled from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';

const D3msOverView: FC = () => {
    const { t } = useLang('referral');

    const list = [
        {
            label: t('d3ms.item1_label'),
            desc: t('d3ms.item1_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548173606-cbrxte-compressed-PC_08.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563048536-6l0n6q-compressed-pic_08.jpg',
        },
        {
            label: t('d3ms.item2_label'),
            desc: t('d3ms.item2_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548192973-rulzvc-compressed-PC_07.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563058788-3arqfn-compressed-pic_07.jpg',
        },
        {
            label: t('d3ms.item3_label'),
            desc: t('d3ms.item3_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548211518-mjzx0s-compressed-PC_06.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563067674-xz7rtr-compressed-pic_06.jpg',
        },
        {
            label: t.rich('d3ms.item4_label', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('d3ms.item4_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548221205-lstd3f-compressed-PC_05.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563076794-clx530-compressed-pic_05.jpg',
        },
        {
            label: t('d3ms.item5_label'),
            desc: t('d3ms.item5_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548230785-wl187u-compressed-PC_04.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563085542-2cx57f-compressed-pic_04.jpg',
        },
        {
            label: t('d3ms.item6_label'),
            desc: t('d3ms.item6_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548252067-4abgc4-compressed-PC_03.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563096346-zxyfo6-compressed-pic_03.jpg',
        },
        {
            label: t('d3ms.item7_label'),
            desc: t('d3ms.item7_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548262594-7vsnzl-compressed-PC_02.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563106783-l7ug7u-compressed-pic_02.jpg',
        },
        {
            label: t.rich('d3ms.item8_label', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('d3ms.item8_desc'),
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1761548272247-6q5eax-compressed-PC_01.jpg',
            imgh5: 'https://websiteoss.ecoflow.com/figma-uploads/1761563120501-svu7g4-compressed-pic_01.jpg',
        },
    ];

    return (
        <div className={`${styled.D3msOverView}`}>
            <EcoSpace />
            <h3 className="title">{t('d3ms.title')}</h3>
            <p className="subtitle">{t('d3ms.subtitle')}</p>
            <div className="overview eco-content">
                {list.map((item, index) => (
                    <div className="overview-item" key={index}>
                        <EcoImg className="item-img" pc={item.img} pad={item.img} h5={item.imgh5} />
                        <div className="overview-text">
                            <p className="overview-label">{item.label}</p>
                            <p className="overview-desc">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className="tips eco-content">
                <p>{t('d3ms.tips1')}</p>
                <p>{t('d3ms.tips2')}</p>
            </div>
        </div>
    );
};

export default D3msOverView;
